<template>
  <div>
    <v-form v-model="valid" ref="form" lazy-validation @submit="reset">
      <v-container class="pt-0">
        <span class="headline">{{$t('common.forgot-password')}}</span>
        <v-row v-if="successMessage">
          <v-col cols="12">
            <alert v-if="successMessage" :text="successMessage" :type="'success'"></alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              ref="email"
              v-model="email"
              type="email"
              :disabled="loading"
              :rules="emailRules"
              autocomplete="username"
              prepend-icon="mdi-account"
              :label="$t('common.email-address')"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="error">
          <v-col>
            <v-card>
              <v-card-text class="error">
                <span style="color:white;">
                  <v-icon>mdi-alert-circle-outline</v-icon>
                  &nbsp;{{error}}
                </span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn
              type="submit"
              color="primary"
              class="mr-4"
              :disabled="!valid || loading || !filled"
              :loading="loading"
            >
              <v-icon left>mdi-email</v-icon>{{$t('forgetPassword.request-link')}}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn class="mr-4" :disabled="loading" link :to="'/login' + ($route.query.redirect ? '?redirect=' + encodeURIComponent($route.query.redirect) : '')">
              <v-icon left>mdi-login</v-icon>{{$t('forgetPassword.back-to-login')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import {} from "@/plugins/store.js";
import Alert from "@/widgets/Alert";

export default {
  name: "ForgotPassword",
  components: {
    Alert,
  },
  data: () => ({
    valid: false,
    loading: false,
    successMessage: undefined,
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    error: undefined
  }),

  mounted() {
    this.email = this.$store.state.auth.emailAddress;
  },

  beforeDestroy() {},

  computed: {
    filled() {
      return this.email && this.email.length > 0;
    }
  },

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset(e) {
      e.preventDefault();
      this.loading = true;
      this.successMessage = undefined;
      console.log("Requesting e-mail link...");
      this.$api
        .requestPasswordResetEMail(this.email)
        .then(response => {
          this.loading = false;
          console.log(response);
          this.resetForm();
          this.successMessage = "Anfrage erfolgreich. Du erhältst in den nächsten Minuten eine E-Mail mit Link um Dein Passwort zurückzusetzen.";
        })
        .catch(error => {
          // also catches the store authorized error
          this.loading = false;
          this.$common.onError(error)
        });
      return false;
    },
    resetForm() {
      this.error = undefined;
      this.email = undefined;
      this.$refs.form.reset();
    }
  }
};
</script>
